declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
    _linkedin_partner_id?: string;
    _linkedin_data_partner_ids?: string[];
  }
}

export function trackPageView(pageName: string) {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
  if (window.gtag) {
    window.gtag("event", "page_view", { page_title: pageName });
  }
}

export function trackLead(source: string) {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "Lead", { source });
  }
  if (window.gtag) {
    window.gtag("event", "generate_lead", { source });
  }
}

export function trackContact(method: string) {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "Contact", { method });
  }
  if (window.gtag) {
    window.gtag("event", "contact", { method });
  }
}

export function trackInitiateCheckout(value?: number, currency = "NGN") {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "InitiateCheckout", { value, currency });
  }
  if (window.gtag) {
    window.gtag("event", "begin_checkout", { value, currency });
  }
}

export function trackCustomEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("trackCustom", eventName, params);
  }
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}

export function trackServiceView(service: string) {
  trackCustomEvent("ViewService", { service });
}
